"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  fetchConfiguration: true
};
Object.defineProperty(exports, "fetchConfiguration", {
  enumerable: true,
  get: function () {
    return _fetchConfiguration.fetchConfiguration;
  }
});
var _fetchConfiguration = require("./internals/fetchConfiguration");
var _contexts = require("./contexts");
Object.keys(_contexts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _contexts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _contexts[key];
    }
  });
});
var _getAuthenticationConfiguration = require("./getAuthenticationConfiguration");
Object.keys(_getAuthenticationConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getAuthenticationConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getAuthenticationConfiguration[key];
    }
  });
});
var _getEnvironmentTenants = require("./getEnvironmentTenants");
Object.keys(_getEnvironmentTenants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getEnvironmentTenants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getEnvironmentTenants[key];
    }
  });
});
var _getEnvironmentTenantsAndLanguages = require("./getEnvironmentTenantsAndLanguages");
Object.keys(_getEnvironmentTenantsAndLanguages).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getEnvironmentTenantsAndLanguages[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getEnvironmentTenantsAndLanguages[key];
    }
  });
});
var _getRegionTenants = require("./getRegionTenants");
Object.keys(_getRegionTenants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getRegionTenants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getRegionTenants[key];
    }
  });
});
var _getRuntimeUrl = require("./getRuntimeUrl");
Object.keys(_getRuntimeUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getRuntimeUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getRuntimeUrl[key];
    }
  });
});
var _getServicesUrls = require("./getServicesUrls");
Object.keys(_getServicesUrls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getServicesUrls[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getServicesUrls[key];
    }
  });
});
var _getUrlsConfiguration = require("./getUrlsConfiguration");
Object.keys(_getUrlsConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getUrlsConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getUrlsConfiguration[key];
    }
  });
});
var _getUrlsConfigurations = require("./getUrlsConfigurations");
Object.keys(_getUrlsConfigurations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getUrlsConfigurations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getUrlsConfigurations[key];
    }
  });
});
var _getUrlsConfigurationsByRegion = require("./getUrlsConfigurationsByRegion");
Object.keys(_getUrlsConfigurationsByRegion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getUrlsConfigurationsByRegion[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getUrlsConfigurationsByRegion[key];
    }
  });
});
var _getUrlsConfigurationsByTenant = require("./getUrlsConfigurationsByTenant");
Object.keys(_getUrlsConfigurationsByTenant).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getUrlsConfigurationsByTenant[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getUrlsConfigurationsByTenant[key];
    }
  });
});
var _getValidatedRequiredServices = require("./getValidatedRequiredServices");
Object.keys(_getValidatedRequiredServices).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getValidatedRequiredServices[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getValidatedRequiredServices[key];
    }
  });
});
var _pickBaseUrlsOfServices = require("./pickBaseUrlsOfServices");
Object.keys(_pickBaseUrlsOfServices).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _pickBaseUrlsOfServices[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pickBaseUrlsOfServices[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
